module.exports = __webpack_public_path__ + "img/photosession_1_4.d077f415.jpg";